<template>
  <el-cascader
    @change="changeValue"
    v-model="citys"
    placeholder="所属区域"
    :options="list"
    filterable
    clearable
    size="mini"
  ></el-cascader>
</template>

<script>
export default {
  name: 'selectcity',
  props: {
    citys: Array,
    city: ""
  },
  data() {
    return {
      list:this.$store.getters['inits/dis'],
    }
  },
  mounted() {
  },
  methods: {
    changeValue() {
      if(this.citys){
        this.$emit('update:citys', this.citys[this.citys.length - 1])
      }else{
        this.$emit('update:city', "")
      }
      this.$emit("success", this.citys)
    },
    
  }
}
</script>

<style scoped>
  
</style>